// dwaar/src/lib/razorpay.js
// Repo: terralekha-core | Folder: dwaar/src/lib/
// Thin wrapper around window.Razorpay so tests can vi.mock this module
// instead of touching window directly (jsdom doesn't support it).

export function openRazorpayCheckout({ keyId, orderId, amount, currency, name, onSuccess, onDismiss }) {
  const options = {
    key:         keyId,
    order_id:    orderId,
    amount,
    currency,
    name:        name ?? "TERRALEKHA",
    description: "CBAM PassPort",
    theme:       { color: "#CBA56A" },
    handler(response) {
      if (onSuccess) onSuccess(response);
    },
    modal: {
      ondismiss() {
        if (onDismiss) onDismiss();
      },
    },
  };
  // eslint-disable-next-line no-undef
  const rzp = new window.Razorpay(options);
  rzp.open();
}
